import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker' 
import logout from './../../Global/logout' 

export default async function PutUser(
        clientUuid, 
        data
    ) {
    const unHashedJwt = await checkJwt()
 
    if(!unHashedJwt){
        logout()
    }

    return await resolve(
        axios( 'provider/client/user/' +  data.uuid + "?clientUuid=" + clientUuid, {
            method: 'PUT',
            headers: { 'Authorization' : unHashedJwt.data},
            data: {
                "username": data.username.trim(),
                "email": data.email.trim(),
                "firstName": data.firstName.trim(),
                "lastName": data.lastName.trim(),
                "enabled": data.enabled
            }      
        }).then(
            res => (res)
        ).catch(error => error.response.data),
        "Admin"
    )
}